import { PartTypeSchema, PartTypeType } from "../types";
import { isBarOrProfile } from "./isBarOrProfile";
import { isSheetPartType } from "./isSheetPartType";

export type DimensionsOverThickness = {
  turning: {
    length: number;
    diameter: number;
  };
  machining: {
    length: number;
    width: number;
    height: number;
  };
  sheet: {
    length: number;
    width: number;
    height: number;
  };
};

export const getOverThicknessFromPartType = (
  partType: PartTypeType | null | undefined,
  overThickness: DimensionsOverThickness,
): { height: number; width: number; length: number } => {
  if (partType === PartTypeSchema.enum.MACHINING) {
    return overThickness.machining;
  }
  if (isSheetPartType(partType)) {
    return overThickness.sheet;
  }
  if (isBarOrProfile(partType)) {
    return {
      height: overThickness.turning.diameter,
      width: overThickness.turning.diameter,
      length: overThickness.turning.length,
    };
  }
  return { height: 0, width: 0, length: 0 };
};
